import "./TableEditor.css";
import axios from "axios";
import { useContext, useMemo, useRef, useState } from "react";
import {
  Add,
  DragIndicatorSharp,
  RemoveRedEye,
  ViewAgenda,
} from "@material-ui/icons";
import { MenuItem } from "@material-ui/core";

import PopupModal, { PopupButton } from "../../Modal/Modal";
import AddNewLessonPlanModal from "../../Modal/AddPlan";
import { Button, GroupHeading } from "../../Component";
import { HeadCell, MemoizedCell } from "./Cell";

import { useLessonPlans } from "../../../../context/LessonPlanProvider";
import { GlobalContext } from "../../../../context/GlobalState";

import { LessonPlanAPIs } from "../../api";
import AddColumnModal from "../../Modal/AddColumn";

function TableEditor(props) {
  const { grades } = useLessonPlans();
  const { userDetails, assignedGrades } = useContext(GlobalContext);
  const [loading, setLoading] = useState("");
  const [popup, setPopup] = useState({ action: "", data: null });
  const draggedItemIndexRef = useRef(-1);

  const handleDragStart = (index) => {
    draggedItemIndexRef.current = index;
    console.log("Dragging", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = async (index) => {
    const oldCols = [...props.columns];
    try {
      const cols = [...props.columns];
      const [movedItem] = cols.splice(draggedItemIndexRef.current, 1);
      cols.splice(index, 0, movedItem);
      const newOrder = { arranged: [], order: [] };
      cols.forEach((col, index) => {
        newOrder.arranged.push({ ...col, colIndex: index });
        if (col.fixed) return;
        newOrder.order.push({
          cellIds: col.cellIds,
          data: {
            colIndex: index,
          },
        });
      });
      props.setColumns([...newOrder.arranged]);

      const column = cols[0];
      await axios.put(
        LessonPlanAPIs.updateCells(column?.teacherId, column?.lessonPlanId),
        { updates: newOrder.order },
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        }
      );
      draggedItemIndexRef.current = -1;
    } catch (err) {
      console.log(err);
      alert("Something went wrong while arranging order!");
      props.setColumn([...oldCols]);
    }
  };

  async function removeColumn() {
    if (loading === "deleting" || !popup?.data) return;
    setLoading("deleting");
    try {
      await axios.delete(
        `${LessonPlanAPIs.removeCells(
          popup.data.teacherId,
          popup.data.lessonPlanId
        )}?ids=${popup.data.cellIds.join(",")}`,
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        }
      );
      props.syncRemovedColumn(popup.data);
      setPopup({});
    } catch (err) {
      console.log(err);
      alert("Something went wrong, while removing new column");
    }
    setLoading("");
  }

  const nextIndex = useMemo(() => {
    const column = props.columns[props.columns.length - 1];
    return (column?.colIndex !== undefined ? column.colIndex : -1) + 1;
  }, [props.columns]);

  return (
    <div className="lp-editor">
      <GroupHeading
        startDate={props.info.startDate}
        backPath={`/lessonplans`}
      />
      <div className="table-grid">
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "20px",
            margin: "0 0 0 0",
          }}
        >
          <Button>
            <MenuItem
              data-bs-toggle="modal"
              data-bs-target="#resourceModal"
              value="url"
              style={{
                fontFamily: "Poppins",
                margin: "0px",
                padding: "0px",
                height: "fit-content",
                minHeight: "fit-content",
                fontWeight: "700",
                letterSpacing: "1px",
              }}
            >
              <Add /> Add Row
            </MenuItem>
          </Button>
          <Button
            style={{ opacity: loading === "column" ? 0.5 : 1 }}
          >
            <MenuItem
              data-bs-toggle="modal"
              data-bs-target="#columnModal"
              value="url"
              style={{
                fontFamily: "Poppins",
                margin: "0px",
                padding: "0px",
                height: "fit-content",
                minHeight: "fit-content",
                fontWeight: "700",
                letterSpacing: "1px",
              }}
            >
              <Add /> {loading === "column" ? "Creating..." : "Column"}
            </MenuItem>
          </Button>
          <div style={{ marginLeft: "auto" }}></div>
          <Button onClick={props.changeView} style={{ marginLeft: "auto" }}>
            <ViewAgenda
              style={{ transform: !props.view ? "rotate(90deg)" : "" }}
            />
            {!props.view ? "Portrait" : "Landscape"}
          </Button>
          <Button onClick={() => props.updateQuery({ action: "download" })}>
            <RemoveRedEye /> Preview
          </Button>
        </div>
        <br />
        <div className="table-container">
          <div className={`table-body ${!props.view ? "" : "landscape-body"}`}>
            {props.columns.map((col, index) => {
              return (
                <div
                  key={col.colName}
                  draggable={!col.fixed}
                  onDrag={() => {
                    if (col.fixed) return;
                    handleDragStart(index);
                  }}
                  onDragOver={handleDragOver}
                  onDrop={() => {
                    if (col.fixed) return;
                    handleDrop(index);
                  }}
                  className={`table-row ${col.fixed ? "fixed-table" : ""}`}
                  style={{ position: "relative" }}
                >
                  <span style={{ opacity: col.fixed ? 0 : 1 }} className="drag">
                    <DragIndicatorSharp />
                  </span>
                  <HeadCell
                    key={`head_${col._id}`}
                    col={col}
                    syncColumn={props.syncColumn}
                    clickRemove={() =>
                      setPopup({ action: "delete", data: col })
                    }
                  />
                  {col.cells.map((row) => {
                    return (
                      <MemoizedCell
                        key={row._id}
                        col={row}
                        syncCell={props.syncCell}
                      />
                    );
                  })}

                  {/*<span className="remove" onClick={() => removeColumn(col._id)}>
                  <Close />
                </span> TEMPORARY DISABLED DELETE COLUMN*/}
                  {popup.data?._id === `${col._id}` ? (
                    <div className="skeleton"></div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <AddNewLessonPlanModal
        userId={userDetails.userId}
        assignedClasses={assignedGrades.grades}
        grades={grades}
        preFilled={{
          startDate: props.info?.startDate
            ? new Date(props.info.startDate)
            : null,
          classesTeaching: props.info.classesTeaching,
          level: props.info.level,
        }}
        refresh={props.refresh}
      />

      <AddColumnModal
        userId={userDetails.userId}
        planIds={props.planIds}
        nextIndex={nextIndex}
        setColumns={props.setColumns}
      />

      <PopupModal
        open={popup.action === "delete"}
        heading="Delete"
        message={
          <>
            Are you sure you want to delete <b>{popup?.data?.colName}</b>{" "}
            column. This action is irreversible
          </>
        }
      >
        <PopupButton
          onClick={() => {
            if (loading) return;
            setPopup({});
          }}
        >
          {" "}
          Cancel
        </PopupButton>
        <PopupButton
          onClick={removeColumn}
          style={{
            background: "#f13a3a",
            color: "#ffffff",
          }}
        >
          {loading === "deleting" ? "Deleting" : "Delete"}
        </PopupButton>
      </PopupModal>
      <PopupModal
        open={popup.action === "message"}
        heading={popup.status}
        message={popup.message}
      >
        <PopupButton onClick={() => setPopup({})}>Close</PopupButton>
      </PopupModal>
    </div>
  );
}

export default TableEditor;
